<div class="sticky" [class.prd-sticky]="region === 'prod'">
  <div class="floating-banner">
    <div><a class="banner-breadcrumb-link" routerLink="/eligibility/add-member">Manage Eligibility</a> / <span>Add Member</span></div>
    <h4>Add New Member</h4>
  </div>
</div>
<div class="add-member-section">
  @if (addMemberFeed(); as addMemberFeed) {
  <div>
    @if (clientPlanDetailsFeed(); as clientPlanDetailsFeed) {
    <client-plan-details [feed]="clientPlanDetailsFeed" (clientInfo)="onClientDetails($event)" [loaderImage]="''"></client-plan-details>
    }
    <elig-add-member #eligAddMemberRef [key]="'BMT'" [languages]="languages()" [clientDetails]="$any(clientDetails())" [addFeatures]="addFeatures()" [selectedAdminPlan]="selectedAdminPlan()"
                     [feed]="$any(addMemberFeed)" [depMemberData]="depMemberDataForLibrary()"
                     (wasAddDone)="wasAddDone($event)"></elig-add-member>
  </div>
  }
</div>
